'use strict';

var jsxRuntime = require('react/jsx-runtime');

const Email = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-email--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M8 25L27.5542 9.88993C28.9948 8.77678 31.0052 8.77678 32.4458 9.88993L52 25V46C52 49.3137 49.3137 52 46 52H14C10.6863 52 8 49.3137 8 46V25Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("rect", {
                    x: "15",
                    y: "13",
                    width: "30",
                    height: "36",
                    rx: "6",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8 25V46C8 49.3137 10.6863 52 14 52H46C49.3137 52 52 49.3137 52 46V25L32.4 39.7C30.9778 40.7667 29.0222 40.7667 27.6 39.7L8 25Z",
                    fill: "white"
                }),
                jsxRuntime.jsx("path", {
                    d: "M8 25L8.42 24.44C8.20789 24.2809 7.9241 24.2553 7.68695 24.3739C7.4498 24.4925 7.3 24.7349 7.3 25H8ZM52 25H52.7C52.7 24.7349 52.5502 24.4925 52.313 24.3739C52.0759 24.2553 51.7921 24.2809 51.58 24.44L52 25ZM32.4 39.7L32.82 40.26L32.4 39.7ZM27.6 39.7L27.18 40.26L27.6 39.7ZM8.7 46V25H7.3V46H8.7ZM14 51.3C11.0729 51.3 8.7 48.9271 8.7 46H7.3C7.3 49.7003 10.2997 52.7 14 52.7V51.3ZM46 51.3H14V52.7H46V51.3ZM51.3 46C51.3 48.9271 48.9271 51.3 46 51.3V52.7C49.7003 52.7 52.7 49.7003 52.7 46H51.3ZM51.3 25V46H52.7V25H51.3ZM51.58 24.44L31.98 39.14L32.82 40.26L52.42 25.56L51.58 24.44ZM31.98 39.14C30.8067 40.02 29.1933 40.02 28.02 39.14L27.18 40.26C28.8511 41.5133 31.1489 41.5133 32.82 40.26L31.98 39.14ZM28.02 39.14L8.42 24.44L7.58 25.56L27.18 40.26L28.02 39.14Z",
                    fill: "#9E9E9E"
                }),
                jsxRuntime.jsx("path", {
                    d: "M37 21H23",
                    stroke: "white",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M37 26H23",
                    stroke: "white",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-email",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M8 25L27.5542 9.88993C28.9948 8.77678 31.0052 8.77678 32.4458 9.88993L52 25V46C52 49.3137 49.3137 52 46 52H14C10.6863 52 8 49.3137 8 46V25Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("rect", {
                x: "15",
                y: "13",
                width: "30",
                height: "36",
                rx: "6",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 25V46C8 49.3137 10.6863 52 14 52H46C49.3137 52 52 49.3137 52 46V25L32.4 39.7C30.9778 40.7667 29.0222 40.7667 27.6 39.7L8 25Z",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                d: "M8 25L8.42 24.44C8.20789 24.2809 7.9241 24.2553 7.68695 24.3739C7.4498 24.4925 7.3 24.7349 7.3 25H8ZM52 25H52.7C52.7 24.7349 52.5502 24.4925 52.313 24.3739C52.0759 24.2553 51.7921 24.2809 51.58 24.44L52 25ZM32.4 39.7L32.82 40.26L32.4 39.7ZM27.6 39.7L27.18 40.26L27.6 39.7ZM8.7 46V25H7.3V46H8.7ZM14 51.3C11.0729 51.3 8.7 48.9271 8.7 46H7.3C7.3 49.7003 10.2997 52.7 14 52.7V51.3ZM46 51.3H14V52.7H46V51.3ZM51.3 46C51.3 48.9271 48.9271 51.3 46 51.3V52.7C49.7003 52.7 52.7 49.7003 52.7 46H51.3ZM51.3 25V46H52.7V25H51.3ZM51.58 24.44L31.98 39.14L32.82 40.26L52.42 25.56L51.58 24.44ZM31.98 39.14C30.8067 40.02 29.1933 40.02 28.02 39.14L27.18 40.26C28.8511 41.5133 31.1489 41.5133 32.82 40.26L31.98 39.14ZM28.02 39.14L8.42 24.44L7.58 25.56L27.18 40.26L28.02 39.14Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M37 21H23",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M37 26H23",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = Email;
